import { IVariable } from "../types";

class NumericVariable implements IVariable {
    constructor(private readonly value: number) {

    }
}

export default NumericVariable;
